// extracted by mini-css-extract-plugin
export default {"title":"q_-z","warning":"r_-z","sizeOptionsLegendText":"s_-z"};